<dx-chart
  class="chart"
  palette="bright"
  [dataSource]="data">
  <dxo-title horizontalAlignment="center" text="G1: Superficie par Tracteur">
    <dxo-font [weight]="300" [size]="18"></dxo-font>
  </dxo-title>
  <!--<dxo-adaptive-layout [height]="300" [width]="400"></dxo-adaptive-layout>-->
  <dxo-legend
    orientation="horizontal"
    itemTextPosition="right"
    horizontalAlignment="center"
    verticalAlignment="bottom"
    [columnCount]="4"></dxo-legend>
  <dxo-export [enabled]="false"></dxo-export>

  <dxi-series valueField="mp" name="Moyenne Puissance"></dxi-series>
  <dxi-series valueField="gp" name="Grande Puissance"></dxi-series>
  <dxo-common-series-settings argumentField="domainName" type="bar">
    <dxo-label
      [visible]="true">
    </dxo-label>
  </dxo-common-series-settings>
</dx-chart>
